import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppRoutingModule} from '../../app/app-routing.module';
import {CartModule} from '../cart/cart.module';
import {SearchFilterModule} from '../search-filter/search-filter.module';
import {LayoutAppComponent, LayoutFullComponent, LayoutLoginComponent} from './components';
import {SharedModule} from '../shared/shared.module';
import {LayoutDownloadComponent} from './components/layout-download/layout-download.component';
import {CoreModule} from '../../core/core.module';

@NgModule({
  declarations: [
    LayoutLoginComponent,
    LayoutAppComponent,
    LayoutFullComponent,
    LayoutDownloadComponent
  ],
  exports: [],
  imports: [
    CommonModule,
    CoreModule,
    AppRoutingModule,
    SearchFilterModule,
    CartModule,
    SharedModule,
  ],
  providers: []
})
export class LayoutsModule {
}
